import { render } from "./SlipAdd.vue?vue&type=template&id=0365fba7&scoped=true"
import script from "./SlipAdd.vue?vue&type=script&lang=js"
export * from "./SlipAdd.vue?vue&type=script&lang=js"

import "./SlipAdd.vue?vue&type=style&index=0&id=0365fba7&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/ADP_CashParis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0365fba7"]])

export default __exports__